import React, { useState, useEffect } from "react";
import Sites from "../../constants/Sites";
import { useTabletDetection } from "helpers/useTabletDetection";
import Sticky from "react-stickynode";
import { ErrorBoundary } from "react-error-boundary";

import styles from "./Layout.module.css";
import "./GlobalLayout2.css";
import EBBMenu from "@components/Header/EBBMenu/EBBMenu";
import Header from "@components/Header/Header";
import NewHeader from "@components/Header/NewHeader";
import Footer from "@components/Footer";
import ContentHeader from "@components/HeaderPage/ContentHeader";
import CatalogHeader from "@components/HeaderPage/CatalogHeader";
import { useAppContext } from "@components/Provider";
import { isIPadProOnSafari } from "../../helpers/Helper";
import GoogleAdSenseDisplay from "../Ads/GoogleAdSenseDispalyAd";
import GoogleAdSense from "../Ads/GoogleAdSense";
import SheKnowsAd from "../Ads/SheKnowsAd";

//Dynamic import based on https://github.com/zeit/next.js/blob/canary/examples/with-dynamic-import/pages/index.js
// {/ Load immediately, but in a separate bundle / }

const renderRightRailAds = ({
  className,
  stickyTop,
  bottomBoundary,
  adnetwork,
  isMobile,
  isTablet,
  isIpadpro,
  removeAds,
}) => {
  if (!isMobile && !isTablet && !isIpadpro) {
    return (
      <div className={className || ""}>
        {removeAds ? (
          <div></div>
        ) : (
          <Sticky bottomBoundary={bottomBoundary} top={stickyTop}>
            {!isMobile && adnetwork && adnetwork === "SheKnows" ? (
              <>
                {/* {/ 300x600 /} */}
                <SheKnowsAd type={"medrec"} />
                <br />
                {/* {/ 300x600 /} */}
                <SheKnowsAd type={"flexrec"} />
              </>
            ) : (
              <>
                <ErrorBoundary fallback={<div className={styles["right_rail_add_layout"]}></div>}>
                  <GoogleAdSense /> <br />
                  <GoogleAdSense />
                </ErrorBoundary>
              </>
            )}
          </Sticky>
        )}
      </div>
    );
  } else
    return (
      <div className={styles["fallbackRightRailContainer_layout"]} style={{ width: "310px" }}></div>
    );
};

const renderDisplayAd = (className, adnetwork, isMobile, displayResponsiveAd, removeAds) => {
  if (!isMobile) {
    return (
      <React.Fragment>
        {removeAds ? (
          <div className={className}></div>
        ) : (
          <div className={className}>
            {adnetwork === "SheKnows" ? (
              displayResponsiveAd ? (
                <SheKnowsAd type={"medrec"} />
              ) : (
                <SheKnowsAd type={"flexbanner"} />
              )
            ) : displayResponsiveAd ? (
              <GoogleAdSense />
            ) : (
              <GoogleAdSenseDisplay />
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
};

const renderEmptyDiv = (siteId, path) => {
  /* {/ Empty div to release sticky right rail ads, don't delete /} */
  if (siteId === Sites.EARLYBIRDBOOKS && path === "/") {
    return <div></div>;
  } else {
    return (
      <div className="empty">
        <br />
      </div>
    );
  }
};

const Layout = (props) => {
  const {
    data,
    siteId,
    router,
    isMobile,
    isTablet: serverIsTablet,
    subscriberCookie,
    isNonClosableModalChecked,
    userAgent,
  } = useAppContext();

  // Enhanced client-side tablet detection using custom hook
  const { isTablet } = useTabletDetection(serverIsTablet, isMobile);

  const [isIpadpro, setIsIpadpro] = useState(true);
  useEffect(() => {
    setIsIpadpro(isIPadProOnSafari(userAgent));
  }, []);
  // const isIpadpro = false; //isIPadProOnSafari();
  const { removeAds } = props.adSettings || false;
  let adnetwork = data.SiteSettings.ad_settings.adnetwork,
    topAdPadding = props.isHeader == true ? styles["paddingTop_layout"] : "";
  // Part of older EBB homepage. See https://openroadmedia.atlassian.net/browse/ORMTECH-1810
  // let isHeader =
  //   siteId == Sites.EARLYBIRDBOOKS
  //     ? router.asPath == "/"
  //       ? isMobile
  //         ? true
  //         : false
  //       : true
  //     : true;
  let isHeader = siteId == Sites.EARLYBIRDBOOKS ? false : true;

  return (
    <React.Fragment>
      {isHeader ? (
        <>
          <Header isNonClosableModalChecked={isNonClosableModalChecked} />
          {!isMobile &&
            (siteId === Sites.OPENROADMEDIA ? (
              <CatalogHeader />
            ) : (
              !isTablet && <ContentHeader isMobile={isMobile} isTablet={isTablet} />
            ))}
        </>
      ) : (
        <>
          <NewHeader />
          {!isMobile && !isTablet && <EBBMenu />}
        </>
      )}
      <div
        className={[
          "layout_container",
          siteId != Sites.OPENROADMEDIA ? styles["containerWithMargin_layout"] : "",
        ].join(" ")}
        style={{
          "--top-padding-1024": !subscriberCookie ? "30px" : "15px",
          "--top-padding-712": !subscriberCookie
            ? siteId == Sites.EARLYBIRDBOOKS
              ? "0"
              : "15px"
            : "15px",
          "--noTopAd_layout-767-top": !subscriberCookie ? "67px" : "40px",
          "--container_layout-top": !subscriberCookie
            ? siteId == Sites.OPENROADMEDIA
              ? "30px"
              : "52px"
            : "15px",
          "--noTopAd_layout-712-top": siteId == Sites.EARLYBIRDBOOKS ? "0px" : "15px",
          "--socialshare-padding": isMobile ? "5px 0 0 0" : "10px",
          "--socialshare-background-color": isMobile ? "transparent" : "#f5f7fa",
          "--socialshare-width": isMobile ? "100%" : "60px",
          "--sticky-outer-wrapper-margin": isMobile ? "" : "300px",
        }}
      >
        {/* {/ Don't display header ad for mobile  /} */}
        <div>
          {renderDisplayAd(
            [styles["topad_layout"], styles["container_layout"], topAdPadding].join(" "),
            adnetwork,
            isMobile,
            false,
            removeAds
          )}
        </div>
        <div className={[styles["container_layout"], styles["noTopAd_layout"]].join(" ")}>
          {props.children}
          {renderRightRailAds({
            className: styles["right_rail_add_layout"],
            stickyTop: 120,
            bottomBoundary: ".empty",
            adnetwork: adnetwork,
            isMobile,
            isTablet,
            isIpadpro,
            removeAds,
          })}
        </div>
        {renderEmptyDiv(siteId, router.asPath)}
        {renderDisplayAd(
          [styles["bottomad_layout"], styles["container_layout"]].join(" "),
          adnetwork,
          false,
          isMobile ? true : false, //If it is mobile, want responvie ad, for desktop need re
          removeAds
        )}
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default Layout;
